import {Fields} from '@vuex-orm/core';
import User from './User';
import Role from '@/users/models/Role';
import {Course, CourseSection} from '@/courses/models';

import {RawCourseRole} from '@/users/types/RawCourseRole';
import {CourseLikeType} from '@/courses/types/CourseLikeType';
import {Joined} from '@/orm/types/Joined';
import {StembleModel} from '@/common/models/StembleModel';

/**
 * CourseRole model that shows a user's role in a course-like
 */
export default class CourseRole
  extends StembleModel
  implements Omit<RawCourseRole, 'user' | 'role'>
{
  static entity = 'CourseRole';

  id!: number;
  userId!: number;
  user!: Joined<User>;
  roleId!: number;
  role!: Joined<Role>;
  courseLikeId!: number;
  courseLikeType!: CourseLikeType;
  courseLike!: Joined<Course | CourseSection>;
  isActive!: boolean;

  static fields(): Fields {
    return {
      id: this.number(null),
      userId: this.number(null),
      user: this.belongsTo(User, 'userId'),
      roleId: this.number(null),
      role: this.belongsTo(Role, 'roleId'),
      courseLikeId: this.number(null),
      courseLikeType: this.string(null),
      courseLike: this.morphTo('courseLikeId', 'courseLikeType'),
      isActive: this.boolean(false),
    };
  }
}
